import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { myTasksService } from '@rd-web-markets/shared/dist/services/task_management/myTasks.service';
import useRecentVisits from '@rd-web-markets/shared/dist/hooks/useRecentVisits';
import RecentActivity from '@rd-web-markets/shared/dist/landing/RecentActivity';
import MyClaims from '@rd-web-markets/shared/dist/landing/MyClaims';
import MyCompanies from '@rd-web-markets/shared/dist/landing/MyCompanies';
import MyTasks from '@rd-web-markets/shared/dist/landing/MyTasks';
import CommonActions from '@rd-web-markets/shared/dist/landing/CommonActions';
import myClaimGroupsService from '@rd-web-markets/shared/dist/services/claim_groups/my_claim_groups.service';
import * as QueryString from 'query-string';
import myCompaniesService from '@rd-web-markets/shared/dist/services/company/my_companies.service';
import SearchBar from '@components/util/SearchBar';

const LandingPageV2 = ({ accountType }) => {
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const history = useHistory();
  const { recentClaimGroupIds, recentCompanyIds } = useRecentVisits();
  const [companies, setCompanies] = useState([]);
  const [claimGroups, setClaimGroups] = useState([]);
  const [tasks] = myTasksService.useFetchAllTasks(setLoading);

  const [searchQuery, setSearchQuery] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const response = await myClaimGroupsService.all(QueryString.stringify());
    const responseCompanies = await myCompaniesService.all(QueryString.stringify());
    setClaimGroups(response.claim_groups);
    setCompanies(responseCompanies.companies);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSearch = (query) => {
    if (!query) return;
    history.push(`/${accountType}/v2/search?query=${encodeURIComponent(query)}`);
  };

  return (
    <div className='p-3 v2-landing'>

      <Row className='align-items-center mb-4'>
        <Col xs={12} md={3}>
          <h4 className='mb-0'>Welcome, {user?.first_name}</h4>
        </Col>
      </Row>

      <Row>
        <Col lg={8}>
          <RecentActivity
            claimGroups={claimGroups}
            companies={companies}
            recentClaimGroupIds={recentClaimGroupIds}
            recentCompanyIds={recentCompanyIds}
            accountType={accountType}
          />
        </Col>
        <Col lg={4}>
          <MyTasks tasks={tasks} />
        </Col>
      </Row>

      <Row className='mt-4'>
        <Col lg={4}>
          <MyClaims claims={claimGroups} accountType={accountType} loading={loading} />
        </Col>
        <Col lg={4}>
          <MyCompanies
            companies={companies}
            claimGroups={claimGroups}
            tasks={tasks}
          />
        </Col>
        <Col lg={4}>
          <CommonActions accountType={accountType} />
        </Col>
      </Row>
    </div>
  );
};

export default LandingPageV2;
